import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';

import { PatientGroupCellModule } from '../patient-group-cell/patient-group-cell.module';
import { AddPatientToGroupModalComponent } from './add-patient-to-group-modal.component';

@NgModule({
  declarations: [AddPatientToGroupModalComponent],
  exports: [AddPatientToGroupModalComponent],
  imports: [
    CommonModule,
    NgxBootstrapIconsModule,
    NgxInnerLoadingModule,
    PatientGroupCellModule,
  ],
})
export class AddPatientToGroupModalModule {}
